<template>
  <div>
    <v-autocomplete
        v-model="localAddress"
        @input="updateData"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        clearable
        item-text="name"
        item-value="id"
        no-data-text="Aucun résultat trouvé"
        :label="descriptions.address"
        placeholder="Rechercher une adresse"
        prepend-icon="mdi-map-search"
      >
      <template v-slot:selection="{ attr, on, item, selected }">
        <span v-html="item.name"></span>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-html="item.name"></v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import _debounce from "lodash/debounce"
import Description from "@/models/Description"
import { stripTags } from "@/utils/helpers"

export default {
  props: {
    address: {
      type: String,
    },
    label: {
      type: String,
      default: "Adresse",
    },
  },
  mounted() {
    const currentAddress = { id: this.address, name: this.address }
    this.items = [currentAddress]
    this.localAddress = currentAddress
  },
  data() {
    return {
      isLoading: false,
      items: [],
      search: null,
      localAddress: {},
    }
  },
  computed: {
    descriptions() {
      return Description.every();
    },  
  },
  watch: {
    search: _debounce(function (val) {
      this.isLoading = true

      // Lazily load input items
      fetch(
        `https://api3.geo.admin.ch/rest/services/cadastre/SearchServer?sr=2056&searchText=${val}&lang=fr&type=locations&limit=20`
      )
        .then((res) => res.clone().json())
        .then((res) => {
          const addresses = res.results.map((item) => {
            return {
              id: stripTags(item.attrs.label),
              name: item.attrs.label,
            }
          })
          this.items = addresses
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    }, 500),
  },
  methods: {
    updateData(field) {
      this.$emit("input", field)
    },
  },
}
</script>
